import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  useMemo,
} from "react";
import { useAxios } from "../customHooks";
import { useLocation } from "react-router-dom";
import { useVideo } from "./Video-Context";
import { useAuth } from "./Auth-Context";

const HistoryContext = createContext();

const HistoryProvider = ({ children }) => {
  const { responseUpdateUserProfile } = useAuth()
  const { operation } = useAxios();
  const { deleteVideoFromDBResponse } = useVideo()
  const {
    response: responseFromWatchHistory,
    isLoading: watchHistoryApiCallLoading,
    operation: deleteFromWatchHistory,
  } = useAxios();
  const {
    response: responseUserWatchHistory,
    operation: fetchUserWatchHistory,
  } = useAxios();
  const [userWatchHistory, setUserWatchHistory] = useState([]);
  const { pathname } = useLocation();
  const encodedToken = localStorage.getItem("myToken");

  const addToHistory = (videoId) => {
    if (encodedToken) {
      operation({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_API}videos/v/${videoId}`,
        headers: { authorization: encodedToken },
      });
    }
  };

  const removeFromHistory = (videoId) => {
    deleteFromWatchHistory({
      method: "delete",
      url: `${process.env.REACT_APP_BACKEND_API}users/v/${videoId}`,
      headers: { authorization: encodedToken },
    });
  };

  useEffect(() => {
    if (responseFromWatchHistory) {
      setUserWatchHistory(responseFromWatchHistory.data.watchHistory);
    }
  }, [responseFromWatchHistory]);

  useEffect(() => {
    if (responseUserWatchHistory) {
      setUserWatchHistory(responseUserWatchHistory.data);
    }
  }, [responseUserWatchHistory]);

  useEffect(() => {
   if(pathname.includes('/history')){
    fetchUserWatchHistory({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_API}users/history`,
      headers: { authorization: encodedToken },
    });
   }
  },[pathname])

  useEffect(() =>{
   if(responseUpdateUserProfile){
    fetchUserWatchHistory({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_API}users/history`,
      headers: { authorization: encodedToken },
    });
   }
  },[responseUpdateUserProfile])

  useEffect(() => {
    if(deleteVideoFromDBResponse != null){
      fetchUserWatchHistory({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_API}users/history`,
        headers: { authorization: encodedToken },
      });
    }
  },[deleteVideoFromDBResponse])

  useEffect(() => {
    if (encodedToken && pathname.includes("/video/")) {
      addToHistory(pathname.replace("/video/", ""));
      fetchUserWatchHistory({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_API}users/history`,
        headers: { authorization: encodedToken },
      });
    }
  }, [pathname, encodedToken]);

  const memoizedContextValue = useMemo(
    () => ({
      addToHistory,
      removeFromHistory,
      userWatchHistory,
      watchHistoryApiCallLoading,
    }),
    [
      addToHistory,
      removeFromHistory,
      userWatchHistory,
      watchHistoryApiCallLoading,
    ]
  );

  return (
    <HistoryContext.Provider value={memoizedContextValue}>
      {children}
    </HistoryContext.Provider>
  );
};

const useHistory = () => useContext(HistoryContext);

export { HistoryProvider, useHistory };
